import styled from 'styled-components';
import {CenteredDivWrap} from '../../../CommonStyleUtils/dwebCommon.styles';
import {Column, Row} from '../../common/Layouts/Layouts';
import StarIconRating from '../../../../Icons/RatingStarIcon';

export const GuestReviewPopUpWrap = styled.div`
  display: flex;
  visibility: hidden;
  width: 28rem;
  position: absolute;
  top: 2.8rem;
  opacity: 1;
  right: -15rem;
  padding: ${props => props.theme.spacing.base};
  z-index: ${props => props.theme.misc.zIndex.base};
  background-color: ${props => props.theme.colors.goWhite.base};
  border-radius: ${props => props.theme.misc.borderRadius.base};
  box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
    ${props => props.theme.colors.shadow.base};
`;

export const HotelTotalReviewWrapper = styled.div(
  props => `
      display: flex;
      align-items:center;
      &:hover > ${GuestReviewPopUpWrap}{
          visibility: visible;
        }
  `,
);

export const ReviewAndRatingOuterContainer = styled.div(
  props => `
  position:relative;
  `,
);

export const HoverTargetWrapperDiv = styled.div`
  flex-direction: row;
  align-items: center;
  display: flex;

  &:hover > ${GuestReviewPopUpWrap} {
    visibility: visible;
  }
`;

export const TotalReviewCountText = styled.span(
  props => `
      color: ${props.theme.colors.downriver.medium};
      padding-right: ${props.theme.spacing.small};
      // margin-right: ${props.theme.spacing.small};
      border-right: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
      
      display: inline-flex;
  `,
);

export const AverageReviewWrapper = styled.div`
  margin-right: ${props => props.theme.spacing.small};
  padding: ${props => props.theme.spacing.custom(2)} ${props => props.theme.spacing.small};
  border-radius: ${props => props.theme.misc.borderRadius.small};
  background-color: ${props => props.bgColor};
  display: flex;
  align-items: center;
`;

export const AverageReviewText = styled.span(
  props => `
    
    font-weight: bold;
    color: ${props.theme.colors.goWhite.base};
    text-align: center;
  `,
);

export const GoRatingBlock = styled(CenteredDivWrap)`
  background-color: ${props => props.bgColor};
  color: ${props => props.theme.colors.goWhite.base};
  flex-direction: column;
  /* align-items: center;
  justify-content: center; */
  width: 13.2rem;
  height: 10.6rem;
  border-radius: ${props => props.theme.misc.borderRadius.large};
  text-align: center;
  margin-right: ${props => props.theme.spacing.small};
`;

export const GoRatingTextWrapper = styled.p(
  props => `
  color: ${props.theme.colors.goGreen.base};
  font-size: ${props.theme.font.custom(22)};
  align-items: center;
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.small};
  opacity: 0.5;
`,
);

export const ReviewCountTextWrapper = styled.p(
  props => `
// color: ${props.theme.colors.goWhite.base};
font-size: ${props.theme.font.custom(14)};
// align-items: center;
padding-top: ${props.theme.spacing.small};
padding-bottom: ${props.theme.spacing.small};
`,
);

export const RatingsCountTextWrapper = styled.p(
  props => `
// color: ${props.theme.colors.goWhite.base};
font-size: ${props.theme.font.custom(14)};
// align-items: center;
padding-bottom: ${props.theme.spacing.base};
`,
);

export const AvgReviewTextWrapperDiv = styled.p(
  props => `
  // display:flex;
  // // flex-direction: row;
  // align-items: center;
  // justify-content:center;
  margin-top: 1rem;
  // color: ${props.theme.colors.goWhite.base};
  font-size: ${props.theme.font.custom(30)};
`,
);

export const AvgReviewTextWrapper = styled.span(
  props => `
  // color: ${props.theme.colors.goGreen.base};

  // align-items: center;
  font-weight: bold;
`,
);

export const TotalReviewTextWrapper = styled.span(
  props => `
  // color: ${props.theme.colors.goGreen.base};
  font-size: 2.6rem;
  align-items: center;
  line-height: 1.1;
  font-weight: bold;
`,
);

export const WrapperDiv = styled(Row)(
  props => `
  width: 70%;
  padding-top: ${props.theme.spacing.base};
  padding-left: ${props.theme.spacing.large};
`,
);

export const ReviewTypeTextWrapper = styled.span`
  padding-right: ${props => props.theme.spacing.small};
  font-weight: bold;
  line-height: 1;
`;

export const ProgressBarWrapperDiv = styled(Row)(
  props => `
  padding-top: ${props.theme.spacing.custom(3)};
  width: 7rem;
`,
);

export const ProgressBarCountWrapper = styled.span`
  padding-left: ${props => props.theme.spacing.large};
  color: ${props => props.theme.colors.downriver.medium};
  flex-direction: row;
`;

export const StarDiv = styled(StarIconRating)(
  props => `
  // width:.9rem;
  // height:.9rem;
  margin-right: ${props.theme.spacing.small};
  fill: red;
`,
);

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: white;
    z-index: 9;
  }
`;

export const TipPositioning = styled(TipUI)`
  right: 60%;
  top: -1.2rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => props.bgColor};
    box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
      ${props => props.theme.colors.shadow.base};
  }
`;

export const BreakupWrapperDiv = styled.div(
  props => `
  width: 70%;
  // padding-top: ${props.theme.spacing.base};
  padding-left: ${props.theme.spacing.custom(3)};
`,
);

export const OverriddenProgressBar = styled(Column)`
  width: 7rem;
  height: 0.8rem;
  background-color: ${props => props.theme.colors.ash.medium};
  border-radius: ${props => props.theme.misc.borderRadius.large};
  position: absolute;
`;

export const BreakupWrapperContainer = styled.div`
  display: flex;
  margin-top: 0.5rem;
`;

export const ProgressLine = styled.span(
  props => `
  background-color: ${props.bgColor};
  border-radius: ${props.theme.misc.borderRadius.large};
  position: relative;
  height: 0.8rem;
  width: ${props.width}rem;
`,
);
